import React from "react";
import PropTypes from "prop-types";
import { Icons } from "../../atoms/Icons";
import { Col, Row } from "react-bootstrap";
import Buttons from "../../atoms/Buttons";
import "./morethan95percentincomemodal.scss";

const MoreThan95PercentIncomeModal = (props) => {
  const handleCloseClick = () => {
    if (typeof props.handleCloseButton === "function") {
      props.handleCloseButton();
    }
  };

  const handleContinueClick = () => {
    if (typeof props.handleContinue === "function") {
      props.handleContinue(
        props.flexiAccessIncomeNewValue,
        props.periodNewValue,
      );
    }
  };

  return (
    <div className="mti-parent">
      <Row className="mb-3">
        <Col>
          <div className="mti-small-close">
            <button
              type="button"
              className="btn btn-link p-0"
              aria-label="Close modal"
              onClick={handleCloseClick}
            >
              <Icons iconname="close" variant="icon-sixteen-px" />
            </button>
          </div>
        </Col>
      </Row>
      <Row className="mti-title mb-3">
        <Col>
          <div>{props.modalTitle}</div>
        </Col>
      </Row>
      <Row className="mti-sub-title mb-5">
        <Col>
          <div>
            <b>
              You’ve requested an income amount that exceeds 95% of your current
              account value.
            </b>
            <br />
            <br />
            Because this income is processed using fund units, the amount shown
            is an estimate. The final value may be slightly higher or lower due
            to changes in unit prices during processing.
          </div>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xl={12} lg={12} md={12}>
          <div className="mti-group-button">
            <span className="mti-cancel-button">
              <Buttons
                name="Cancel"
                className="secondary"
                variantname="icon-sixteen-px"
                handleClick={handleCloseClick}
              ></Buttons>
            </span>
            <Buttons
              name="Continue"
              className="primary"
              variantname="icon-sixteen-px"
              handleClick={handleContinueClick}
            ></Buttons>
          </div>
        </Col>
      </Row>
    </div>
  );
};

MoreThan95PercentIncomeModal.propTypes = {
  handleCloseButton: PropTypes.func,
  handleContinue: PropTypes.func,
  modalTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  flexiAccessIncomeNewValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  periodNewValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MoreThan95PercentIncomeModal.defaultProps = {
  handleCloseButton: undefined,
  handleContinue: undefined,
  modalTitle: "",
  flaggedStrategyNames: [],
};

export default MoreThan95PercentIncomeModal;
